// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataGroupes = createAsyncThunk('appUsers/getAllDataGroupes', async (id) => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/user/groupes/all', { params: { id} })
  return response.data
})

export const getDataGroupes = createAsyncThunk('appUsers/getDataGroupes', async params => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/user/groupes/data', { params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const addUserToGroupe = createAsyncThunk('appUsers/addUserToGroupe', async (group, { getState }) => {
  //  option.client_id = getState()
    console.log("addPrivilgeToGroup")
    
    group.user_id = getState().users.selectedUser.id
    
    
    await axios.post('https://apiv4dev2.opentlv.com/api/v3/user/addusertogroupes', group)
    //.wait dispatch(getGroupPrivilegesData(getState().groupPrivileges.params))
  
    //await d
  })


export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataGroupes.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataGroupes.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
  }
})

export default appUsersSlice.reducer
